import { render, staticRenderFns } from "./frontInventario.vue?vue&type=template&id=795e045f&"
import script from "./frontInventario.vue?vue&type=script&lang=js&"
export * from "./frontInventario.vue?vue&type=script&lang=js&"
import style0 from "./frontInventario.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports